import { yupResolver } from '@hookform/resolvers/yup';
import { ChevronLeftIcon, EnterIcon } from '@radix-ui/react-icons';
import { Button, Card, Flex, Spinner } from '@radix-ui/themes';
import { useForm } from 'react-hook-form';
import toast from 'react-hot-toast';
import { useMutation } from 'react-query';
import { useNavigate } from 'react-router-dom';
import { createProjectType } from '../../../services/scientific/projectType';
import { ProjectTypesType } from '../../../types/ScientificModule';
import { CreateProjectTypeFormValidation } from './CreateProjectTypeFormValidation';
import { routes } from '../../../routes';
import TextFieldComponent from '../../../components/inputs/Textfield/TextfieldComponent';


export const  CreateProjectType=()=> {
  const navigate = useNavigate();
  const mutation = useMutation({ mutationFn: createProjectType, mutationKey: 'createProjectType' });

  const defaultValues: ProjectTypesType = {
    description: ''
  }
  const { control, handleSubmit, setValue, getValues, formState: { errors } } = useForm<ProjectTypesType>({
    resolver: yupResolver(CreateProjectTypeFormValidation),
    defaultValues,
    mode: 'onBlur',
    reValidateMode: 'onBlur',
    shouldUseNativeValidation: false,
  });

  const onSubmit = handleSubmit(async (data) => {
    try {
      const result = await mutation.mutateAsync(data);
      if (result) {
        toast.success("Criada!");
        navigate(routes.projectTypes);
      }
    } catch (err: any) {
      toast.error(`${mutation.error ?? err?.message}`);
    }
  });

  const handleBack = () => {
    navigate(routes.projectTypes);
  }
  return ( <form onSubmit={onSubmit} noValidate>
      <Card size='1'>
        <Flex direction='column' gap='4'>
            <TextFieldComponent name="description" label="Descrição" control={control} errors={errors} fieldProps={{ placeholder: 'Descrição' }} required={true}/>
          <Flex direction='row' gap='4' style={{ alignSelf: 'end' }}>
            <Button color='red' onClick={handleBack} disabled={mutation.isLoading}>
              <ChevronLeftIcon /> voltar
            </Button>
            <Button type="submit" disabled={mutation.isLoading} variant='surface'>
              {mutation.isLoading ? <Spinner loading> <EnterIcon /></Spinner> : <EnterIcon />}
              Registar
            </Button>
          </Flex>
        </Flex>
      </Card>
    </form>
  );
}